import React, { useState, useEffect } from "react";
import CustomerInfoEdit from "./CustomerInfoEdit";
import ReactDOM from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import CampaignService from "../../service/CampaignService";

// 이미지 있음 아이콘 (사진 아이콘)
const PhotoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 text-green-500"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m0 0l-4.586-4.586a2 2 0 00-2.828 0L4 16m12 0H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v8a2 2 0 01-2 2h-4zm4-10v.01M4 8h16M2 20h20"
    ></path>
  </svg>
);

function BackIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 12H5" />
      <path d="M12 19l-7-7 7-7" />
    </svg>
  );
}

function RightArrowIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}

function SearchIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
  );
}

export default function CustomerInformation({
  toggleDrawerProp,
  orderNo,
  salesNo,
  orderKey,
}) {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [travelerInfo, setTravelerInfo] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // 검색어 상태 추가
  const [customerNo, setCustomerNo] = useState(null);
  const [usePassport, setUsePassport] = useState(false); //여권정보필요여부
  const [useLock, setUseLock] = useState(false); //잠금여부
  const [productType, setProductType] = useState(null); //상품타입 (309206,309302)
  const [showTicketConfirm, setShowTicketConfirm] = useState(false); //발권 확인 팝업
  const [agreeToTicket, setAgreeToTicket] = useState(false); //발권 동의 체크박스

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const toggleDrawer = (item, data, useImage) => {
    if (item) {
      setCustomerNo(item);
    }
    setDrawerOpen(!drawerOpen);

    //data 정보로 setTravelerInfo에 여행객번호가 같으면 업데이트 해줘
    if (data) {
      // if (selectedTab) {
      setTravelerInfo((prev) =>
        prev.map((item) => {
          if (item.여행객번호 === data.여행객번호) {
            return {
              ...item,
              ...data,
              여권사본경로: useImage,
            };
          }
          return item;
        })
      );
      // } else {
      //   setTravelerInfo((prev) =>
      //     prev.filter((item) => item.여행객번호 !== data.여행객번호)
      //   );
      // }
    }
  };
  const handleBackClick = () => {
    toggleDrawerProp();
  };

  useEffect(() => {
    const body = document.body;
    if (drawerOpen) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "";
    }

    // Cleanup function to reset overflow style
    return () => {
      body.style.overflow = "";
    };
  }, [drawerOpen]);

  useEffect(() => {
    TravelerInfo();
  }, [selectedTab]);

  // const salesNoSave = async () => {
  //   if (orderNo === null || salesNo === null || orderKey === null) {
  //     navigate(`/error`);
  //     return;
  //   }

  //   try {
  //     const result = await CampaignService.SalesNoSave(
  //       orderNo,
  //       salesNo,
  //       orderKey
  //     );

  //     await TravelerInfo();
  //   } catch (error) {
  //     navigate(`/error`);
  //   } finally {
  //   }
  // };

  const TravelerInfo = async () => {
    //console.log("orderNo", orderNo, salesNo, orderKey, selectedTab);
    if (orderNo === null || salesNo === null || orderKey === null) {
      navigate(`/error`);
      return;
    }

    try {
      const result = await CampaignService.TravelerListAll(
        orderNo,
        salesNo,
        orderKey,
        selectedTab
      );

      if (result?.table) {
        setTravelerInfo(result.table);
        setUsePassport(false);
        setUseLock(result?.table1?.[0]?.명단잠금여부 || false);
        setProductType(result?.table1?.[0]?.상품타입 || "");
        //setUsePassport(result.table1[0].여권사본필요여부);
      } else {
        setTravelerInfo(null);
      }
    } catch (error) {
      navigate(`/error`);
    } finally {
    }
  };

  const filteredTravelerInfo = travelerInfo?.filter((item) => {
    // 소문자로 변환된 검색어

    const searchLower = searchTerm.toLowerCase();

    // 각 필드가 null이나 빈값일 경우를 대비하여 기본값 ""(빈 문자열)을 사용
    const koreanName = item.한글이름 ? item.한글이름.toLowerCase() : "";
    const englishName =
      item.영문성 && item.영문이름
        ? `${item.영문성} ${item.영문이름}`.toLowerCase()
        : "";
    const phone = item.휴대폰 ? item.휴대폰.toLowerCase() : "";
    const sex = item.성별 ? item.성별.toLowerCase() : "";
    const email = item.이메일 ? item.이메일.toLowerCase() : "";
    const passportNumber = item.여권번호 ? item.여권번호.toLowerCase() : "";

    // 검색 대상 필드에 검색어가 포함되어 있는지 확인
    const matchKoreanName = koreanName.includes(searchLower);
    const matchEnglishName = englishName.includes(searchLower);
    const matchPhone = phone.includes(searchLower);
    const matchSex = sex.includes(searchLower);
    const matchEmail = email.includes(searchLower);
    const matchPassportNumber = passportNumber.includes(searchLower);

    // 하나라도 매칭되면 true를 반환하여 해당 항목을 포함시킴
    return (
      matchKoreanName ||
      matchEnglishName ||
      matchPhone ||
      matchSex ||
      matchEmail ||
      matchPassportNumber
    );
  });

  return (
    <>
      <div className="min-h-screen w-full bg-gray-100 mx-auto max-w-[500px] p-4">
        <div className="fixed top-0 left-1/2 transform -translate-x-1/2 max-w-[500px] w-full bg-white p-4  rounded-b-0 shadow z-10 ">
          <div className="flex justify-between items-center mb-0">
            <div className="flex items-center  ">
              <button onClick={handleBackClick} className="mr-2">
                <BackIcon className="text-slate-900  h-6 w-6" />
              </button>
              <div className="text-lg font-bold">여행객</div>
            </div>
            {/* 검색 입력란 */}
            {/* <div className="flex items-center space-x-2">
              <SearchIcon className="text-gray-500  h-6 w-6" />
              <input
                className="flex-1 focus:outline-none bg-transparent border-none text-gray-600 text-sm"
                placeholder="여행객 검색"
                type="text"
                value={searchTerm}
                onChange={handleSearchChange} // 입력 시 검색어 상태 업데이트
              />
            </div> */}
          </div>
          {/* 여기에 다른 내용들... */}

          {/* 탭 구현 */}
          {/* <div className="flex border-b-[1px] border-gray-200 text-sm mt-2">
            <button
              className={`flex-1 py-2 ${
                selectedTab === false
                  ? "border-b-2 border-blue-500 font-semibold"
                  : "text-gray-500"
              }`}
              onClick={() => setSelectedTab(false)}
            >
              미입력 여행객
             
            </button>
            <button
              className={`flex-1 py-2 ${
                selectedTab === true
                  ? "border-b-2 border-blue-500 font-semibold"
                  : "text-gray-500 "
              }`}
              onClick={() => setSelectedTab(true)}
            >
              입력 완료 여행객
             
            </button>
          </div> */}

          <div className="flex items-center space-x-2 bg-gray-100 mt-2 py-2 rounded-2">
            <SearchIcon className="text-gray-500  h-5 w-5 ml-2" />
            <input
              className="flex-1 focus:outline-none bg-transparent border-none text-gray-600 text-sm"
              placeholder="검색"
              type="text"
              value={searchTerm}
              onChange={handleSearchChange} // 입력 시 검색어 상태 업데이트
            />
          </div>
        </div>

        <div
          className={`space-y-2 mt-[100px] ${
            productType === "309206" || productType === "309302" ? "pb-24" : ""
          }`}
        >
          {filteredTravelerInfo && filteredTravelerInfo.length > 0 ? (
            filteredTravelerInfo.map((item, index) => {
              return (
                <div
                  key={item.여행객번호}
                  className="bg-white p-4 rounded-lg shadow w-full"
                >
                  <div className="flex items-center w-full">
                    <div className="flex items-center space-x-2 w-full">
                      {/* <CheckCircleIcon className="text-green-500" /> */}
                      <div className="flex flex-col gap-1 w-full">
                        <div className="flex justify-between w-full">
                          <div className="flex gap-3  ">
                            <div
                              className={`font-semibold border px-3 text-xs flex items-center  text-white 

                          ${
                            item.연령구분 === "성인"
                              ? "bg-blue-400"
                              : item.연령구분 === "소아"
                              ? "bg-green-400"
                              : "bg-yellow-400"
                          }
                          
                          `}
                            >
                              {item.연령구분 || ""}
                            </div>
                            {/* <div className="font-semibold">{item.한글이름 || ""}</div> */}
                            <div className="font-semibold overflow-hidden overflow-ellipsis whitespace-nowrap max-w-[150px]">
                              {item.한글이름 || ""}
                            </div>
                          </div>

                          <div
                            className={`text-xs bg-slate-700 rounded-[4px] text-white py-1 px-2  cursor-pointer 
                            ${
                              useLock
                                ? "!bg-gray-400 cursor-not-allowed"
                                : "bg-slate-700"
                            }
                            `}
                            onClick={() =>
                              !useLock && toggleDrawer(item.여행객번호)
                            }
                          >
                            정보수정
                          </div>
                        </div>
                        <div className="flex mt-1 ">
                          <div className="text-sm text-gray-500 w-[100px]">
                            성별
                          </div>
                          <div className="text-sm text-gray-500 max-w-[180px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
                            {item?.성별 || ""}
                          </div>
                        </div>

                        <div className="flex ">
                          <div className="text-sm text-gray-500 w-[100px]">
                            영문이름
                          </div>
                          <div className="text-sm text-gray-500 max-w-[180px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
                            {` ${item?.영문성 || ""} / ${
                              item.영문이름 || ""
                            }   `}
                          </div>
                        </div>

                        <div className="flex ">
                          <div className="text-sm text-gray-500 w-[100px]">
                            생년월일
                          </div>
                          <div className="text-sm text-gray-500 max-w-[180px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
                            {item?.생년월일 || ""}
                          </div>
                        </div>

                        {/* <div className="flex ">
                          <div className="text-sm text-gray-500 w-[100px]">
                            휴대폰
                          </div>
                          <div className="text-sm text-gray-500 max-w-[180px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
                            {item?.휴대폰 || ""}
                          </div>
                        </div> */}
                        {/* 
                        <div className="flex ">
                          <div className="text-sm text-gray-500 w-[100px]">
                            이메일
                          </div>
                          <div className="text-sm text-gray-500 max-w-[180px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
                            {item?.이메일 || ""}
                          </div>
                        </div> */}

                        {usePassport ? (
                          <>
                            <div className="flex ">
                              <div className="text-sm text-gray-500 w-[100px]">
                                여권번호
                              </div>
                              <div className="text-sm text-gray-500 max-w-[180px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
                                {item?.여권번호 || ""}
                              </div>
                            </div>

                            <div className="flex ">
                              <div className="text-sm text-gray-500 w-[100px]">
                                여권만료일
                              </div>
                              <div className="text-sm text-gray-500 max-w-[180px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
                                {item?.여권만료일 || ""}
                              </div>
                            </div>

                            <div className="flex ">
                              <div className="text-sm text-gray-500 w-[100px]">
                                여권발급일
                              </div>
                              <div className="text-sm text-gray-500 max-w-[180px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
                                {item?.여권발급일 || ""}
                              </div>
                            </div>

                            {/* 여권사본 이미지 아이콘 표시 */}

                            <div className="flex ">
                              <div className="text-sm text-gray-500 w-[100px]">
                                여권사본
                              </div>
                              <div className="text-sm text-gray-500 max-w-[180px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
                                {item?.여권사본경로 ? "첨부완료" : null}
                                {/* {item?.여권사본경로 ? (
                              <PhotoIcon className="text-gray-500" />
                            ) : null} */}
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                    {/* <RightArrowIcon className="text-gray-600" onClick={() => toggleDrawer(item.여행객번호)} /> */}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center py-10">
              <p className="text-slate-500">정보가 없습니다.</p>
            </div>
          )}
        </div>

        {/* 발권 요청 버튼 */}
        {(productType === "309206" || productType === "309302") && (
          <div className="fixed bottom-0 left-1/2 transform -translate-x-1/2 max-w-[500px] w-full bg-white p-4 shadow-lg">
            <button
              className={`w-full py-3 px-4 rounded-lg font-semibold text-base ${
                !useLock &&
                travelerInfo &&
                travelerInfo.length > 0 &&
                travelerInfo.every(
                  (item) =>
                    item.한글이름 &&
                    item.성별 &&
                    item.영문성 &&
                    item.영문이름 &&
                    item.생년월일
                )
                  ? "bg-cyan-500 text-white cursor-pointer"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
              onClick={() => {
                if (
                  !useLock &&
                  travelerInfo &&
                  travelerInfo.length > 0 &&
                  travelerInfo.every(
                    (item) =>
                      item.한글이름 &&
                      item.성별 &&
                      item.영문성 &&
                      item.영문이름 &&
                      item.생년월일
                  )
                ) {
                  setShowTicketConfirm(true);
                  setAgreeToTicket(false);
                }
              }}
            >
              {useLock ? "명단 입력 완료" : "발권 요청"}
            </button>
          </div>
        )}
      </div>

      {/* Drawer Component */}
      {drawerOpen &&
        ReactDOM.createPortal(
          <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex justify-end">
            <div className="h-full w-full md:w-full bg-white overflow-y-auto">
              <CustomerInfoEdit
                toggleDrawerProp={toggleDrawer}
                orderNo={orderNo}
                salesNo={salesNo}
                orderKey={orderKey}
                customerNo={customerNo}
              />
            </div>
          </div>,
          document.body
        )}

      {/* 발권 확인 팝업 */}
      {showTicketConfirm &&
        ReactDOM.createPortal(
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg w-full max-w-sm mx-auto">
              {/* 팝업 헤더 */}
              <div className="p-4 border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-900">
                  명단 확정
                </h3>
              </div>

              {/* 팝업 내용 */}
              <div className="p-4">
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  입력된 정보로 발권이 진행되며, 발권 후에는 정보 변경이 불가
                  합니다. 명단 확정 및 발권을 요청하시겠습니까?
                </p>

                {/* 동의 체크박스 */}
                <div className="flex items-center mb-4">
                  <input
                    type="checkbox"
                    id="agreeTicket"
                    checked={agreeToTicket}
                    onChange={(e) => setAgreeToTicket(e.target.checked)}
                    className="w-4 h-4 text-cyan-500 bg-gray-100 border-gray-300 rounded focus:ring-cyan-500 focus:ring-2"
                  />
                  <label
                    htmlFor="agreeTicket"
                    className="ml-2 text-sm text-gray-700"
                  >
                    위 내용을 확인하고 동의합니다
                  </label>
                </div>
              </div>

              {/* 팝업 버튼 */}
              <div className="flex gap-2 p-4 border-t border-gray-200">
                <button
                  onClick={() => {
                    setShowTicketConfirm(false);
                    setAgreeToTicket(false);
                  }}
                  className="flex-1 py-2 px-4 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  취소
                </button>
                <button
                  onClick={async () => {
                    if (agreeToTicket) {
                      try {
                        // 발권 요청 로직 실행
                        const result = await CampaignService.SalesNoSave(
                          orderNo,
                          salesNo,
                          orderKey
                        );

                        await TravelerInfo();
                        //window.location.reload();
                      } catch (error) {
                        console.error("발권 요청 오류:", error);
                      } finally {
                        setShowTicketConfirm(false);
                        setAgreeToTicket(false);
                      }
                    }
                  }}
                  disabled={!agreeToTicket}
                  className={`flex-1 py-2 px-4 text-sm font-medium rounded-lg transition-colors ${
                    agreeToTicket
                      ? "bg-cyan-500 text-white hover:bg-cyan-600"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  }`}
                >
                  발권요청
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
